<template>
  <div>

    <div class="ibox">
      <div class="ibox-title pt-3">
        <h5><strong>Empresa</strong></h5>
      </div>
      <div class="ibox-content">

        <div class="row">
          <div class="col-md-6">
            <div>
              <p><strong>{{ company.name | uppercase }}</strong></p>
            </div>
            <div>
              <p><strong>CNPJ: </strong>{{ company.cnpj | cnpj }}</p>
            </div>
            <div>
              <p><strong>IE: </strong>{{ company.ie }}</p>
            </div>
            <div>
              <p><strong>IM: </strong>{{ company.im }}</p>
            </div>
            <div>
              <p><strong>UF: </strong>{{ company.uf }}</p>
            </div>
            <div>
              <p><strong>Matriz: </strong>{{ company.type === 'parent' ? 'Sim' : 'Não' }}</p>
            </div>
          </div>

          <div class="col-md-6">
            <div>
              <p><strong>Certificado Digital: </strong>
                <strong v-if="checkDate(company.certificateExpiringAt)">
                  {{ company.certificateExpiringAt | certificate }}
                </strong>
                <strong v-else style="color: red">
                  {{ company.certificateExpiringAt | certificate }}
                </strong>
              </p>
            </div>
            <div>
              <p><strong>Data da criação: </strong>{{ company.createdAt | date }}</p>
            </div>
            <div>
              <p><strong>Email: </strong>{{ company.email }}</p>
            </div>
            <div>
              <p><strong>Telefone: </strong>{{ company.phone }}</p>
            </div>
            <div>
              <p><strong>Criado por: </strong>{{ company.createdBy }}</p>
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-md-12">
            <button v-if="$withPolicy('application', 'companies/insert_or_update')"
                    class="btn btn-outline btn-md mr-2"
                    @click="$emit('editCompany', company)">
              Editar
            </button>

            <span class="company-status-label mr-2">Status da Empresa:</span>
            <CompanyStatusToggle :company="company" @request-toggle="pendingToggle = $event"/>

            <button v-if="$withPolicy('application', 'companies/delete')" class="btn btn-outline-red float-right"
                    @click="$emit('sendDeleteCompany', company)">
              Excluir empresa
            </button>
          </div>
        </div>
      </div>
    </div>

    <ModalToggleCompanyStatus
      v-if="pendingToggle"
      :value="true"
      :company="pendingToggle.company"
      :action="pendingToggle.action"
      @input="pendingToggle = null"
      @confirmed="onStatusConfirmed"
    />

    <Container :parentCompany="company"/>

    <CardProviders v-if="getUser.role === 'owner'" :company="company"/>

    <CardUser :company="company"/>

    <CardCredentials v-if="hasCmEmbarcador" :company="company"/>

    <Services
      v-if="accountApps.length > 0"
      :accountApps="accountApps"
      :company="company"
    />

  </div>
</template>

<script>
  import CardCredentials from '@/components/company/CardCredentials'
  import CardProviders from '@/components/company/CardProviders'
  import CardUser from '@/components/company/CardUser'
  import Container from '@/components/company/subcompany/Container'
  import Services from '@/components/company/container/Services'
  import CompanyStatusToggle from '@/components/company/CompanyStatusToggle'
  import ModalToggleCompanyStatus from '@/components/company/ModalToggleCompanyStatus'
  import { COMPANY_STATUS } from '@/utils/companyStatus'

  import GetUser from '@/mixins/GetUser'
  import GetAccountApps from '@/mixins/GetAccountApps'

  export default {
    components: { CardCredentials, CardProviders, CardUser, CompanyStatusToggle, Container, ModalToggleCompanyStatus, Services },
    data() {
      return {
        pendingToggle: null
      }
    },
    computed: {
      accountApps() {
        return this.getAccountApps.filter(aa => ['cm-embarcador'].includes(aa.name) && aa.active)
      },
      hasCmEmbarcador() {
        return this.getAccountApps.some(aa => aa.name === 'cm-embarcador' && aa.active)
      }
    },
    methods: {
      checkDate(string) {
        if (string) {
          const date = new Date(string)
          return date > new Date()
        }
      },
      onStatusConfirmed(company) {
        const entityStatusId = this.pendingToggle && this.pendingToggle.action === 'disable'
          ? COMPANY_STATUS.DISABLED
          : COMPANY_STATUS.ENABLED
        this.$set(company, 'entityStatusId', entityStatusId)
        this.pendingToggle = null
      },
    },
    mixins: [GetAccountApps, GetUser],
    name: 'Show',
    props: {
      company: { required: true, type: Object }
    }
  }
</script>

<style scoped lang="scss">
 .card{
    height: 100%;
  }

  p{
    color: var(--primary-text-color);
  }

  .table td{
    vertical-align: middle;
  }

  .company-status-label {
    font-weight: bold;
    vertical-align: middle;
  }

</style>
